<template>
  <div id="app" class="g-layout">
    <v-header v-show="$route.meta.isHeader" :class="{'grey':isgrey}"></v-header>
    <v-header-two v-show="$route.meta.isHeader" :class="{'grey':isgrey}"></v-header-two>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" class="main-body" :class="{'grey':isgrey}" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" class="main-body" :class="{'grey':isgrey}" />
    <v-footer :class="{'grey':isgrey,'noMargin':!$route.meta.isFooterMargin}"></v-footer>
    <v-player v-if="$route.meta.isplayer" :class="{'grey':isgrey}"></v-player>
    <!-- <v-header></v-header>
    <keep-alive><router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" class="body" /></keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" class="body" /> -->
    <!-- <v-footer></v-footer>
    <v-player></v-player> -->
  </div>
</template>

<script>
import Header from './components/Header_v3'
import HeaderTwo from './components/HeaderTwo'
import Footer from './components/Footer_v3'
import Player from './components/Player'
export default {
  name: 'App',
  data () {
    return {
      isgrey:false,//网站置灰
    }
  },
  components:{
    'v-header':Header,
    'v-header-two':HeaderTwo,
    'v-footer':Footer,
    'v-player':Player,
  },
  watch: {
    $route(to, from) {
      if(this.$matomo){
        this.$matomo.setCustomUrl(window.location.href)
      }
      // 网站置灰
      // if(to.fullPath === '/'){
      //   this.isgrey = true;
      // }else{
      //   this.isgrey = false;
      // }
    },
  },
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 900px) {
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue